import { gql } from '@apollo/client';

const Fragments = {
  financialIndicator: gql`
    fragment financialIndicator on FinancialIndicator {
      id
      orderNo
      code
      name
    }
  `
};

export default Fragments;
